<template>
  <ul class="product-comments-list">
    <CommentItem
      v-for="comment in commentsForRender"
      :key="comment.comment_id"
      :is-short="isShort"
      :comment="comment"
      :endpoint="endpoint"
      :product-id="productId"
      :is-questions="isQuestions"
    />
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import CommentItem from './CommentItem'

export default {
  name: 'CommentsList',
  components: {
    CommentItem
  },
  props: {
    isShort: {
      type: Boolean,
      default: false
    },
    isQuestions: {
      type: Boolean,
      default: false
    },
    endpoint: {
      type: String,
      required: true
    },
    productId: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapState({
      comments: state => state.comments.comments,
      questions: state => state.questions.comments
    }),
    commentsForRender () {
      let source = this.comments
      if (this.isQuestions) {
        source = this.questions
      }
      if (source.comments) {
        if (this.isShort) return source.comments.slice(0, 3)

        return source.comments
      }
      return null
    }
  }
}
</script>

<style scoped lang="sass">

.product-comments-list
  +list-unstyled
  display: block
  width: 100%

</style>
